const rows = [
  {
    feature: "Appointment Required",
    agency: "Yes — limited availability, often weeks out",
    fpc: "No appointment needed to start",
    fpcGood: true,
  },
  {
    feature: "In-Person Visit",
    agency: "Required — drive to Atlanta or New Orleans Passport Agency",
    fpc: "Most travelers ship documents overnight",
    fpcGood: true,
  },
  {
    feature: "Processing Speed",
    agency: "Urgent travel only — strict eligibility",
    fpc: "As fast as 24 hours — multiple speed options",
    fpcGood: true,
  },
  {
    feature: "Document Review",
    agency: "None — errors cause rejection",
    fpc: "Professional review to reduce delays",
    fpcGood: true,
  },
  {
    feature: "Courier Access",
    agency: "Not available to the public",
    fpc: "Reserved daily submission availability",
    fpcGood: true,
  },
  {
    feature: "Predictability",
    agency: "Appointments can be cancelled or unavailable",
    fpc: "Predictable processing based on option selected",
    fpcGood: true,
  },
  {
    feature: "Who Can Use It",
    agency: "Strict eligibility — urgent travel only",
    fpc: "Most U.S. citizens with required documents",
    fpcGood: true,
  },
  {
    feature: "Cost vs Resellers",
    agency: "Not applicable",
    fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers",
    fpcGood: true,
  },
  {
    feature: "Direct State Dept. Access",
    agency: "Not available to the public",
    fpc: "Registered courier — not a middleman or reseller",
    fpcGood: true,
  },
];

export default function PensacolaComparisonSection() {
  return (
    <section id="comparison" className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Emergency Passports</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Regional Passport Agency vs. Fast Passport Center
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            If you need your passport <strong className="text-[#1A365D]">within two weeks</strong>, the Atlanta Passport Agency (230 Peachtree St NW, Suite 1000, Atlanta, GA 30303) is your closest do-it-yourself option — and getting an appointment there is rarely straightforward. Fast Passport Center gives you a faster, simpler path without the uncertainty.
          </p>
        </div>

        <div className="rounded-lg overflow-hidden border border-gray-200">
          {/* Header */}
          <div className="grid grid-cols-3 bg-[#1A365D] text-white">
            <div className="p-4 text-sm font-semibold text-white/50">Feature</div>
            <div className="p-4 text-sm font-semibold text-center border-l border-white/10">
              <i className="ri-government-line mr-1.5"></i>Regional Passport Agency
            </div>
            <div className="p-4 text-sm font-semibold text-center border-l border-white/10 bg-[#F6C344]/15">
              <i className="ri-shield-check-line mr-1.5 text-[#F6C344]"></i>Fast Passport Center
            </div>
          </div>

          {rows.map((row, i) => (
            <div
              key={i}
              className={`grid grid-cols-3 border-t border-gray-100 ${i % 2 === 0 ? "bg-white" : "bg-[#F7F8FA]"}`}
            >
              <div className="p-4 text-sm font-semibold text-[#1A365D]">{row.feature}</div>
              <div className="p-4 text-sm text-gray-500 border-l border-gray-100 flex items-start gap-2">
                <i className="ri-close-circle-line text-red-400 flex-shrink-0 mt-0.5"></i>
                <span>{row.agency}</span>
              </div>
              <div className="p-4 text-sm text-gray-700 border-l border-gray-100 flex items-start gap-2 bg-[#F6C344]/5">
                <i className="ri-checkbox-circle-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                <span className="font-medium">{row.fpc}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Expedited Passport <i className="ri-arrow-right-line"></i>
          </a>
          <p className="text-gray-400 text-xs mt-3">
            Atlanta Passport Agency &mdash; 230 Peachtree St NW, Suite 1000, Atlanta, GA 30303 &mdash; Closest regional office to Pensacola
          </p>
        </div>
      </div>
    </section>
  );
}